import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwalalertService {

  constructor() { }
  
   // 🔹 Simple Alert
   showAlert(title: string, text: string, icon: 'success' | 'error' | 'warning' | 'info') {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: 'OK'
    });
  }

  // 🔹 Confirmation Alert with a Red "Confirm" Button
  showConfirmAlert(title: string, text: string,confirmButton:string,cancelButtonText:string): Promise<boolean> {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmButton ,
      cancelButtonText: cancelButtonText,
      didOpen: () => {
        const confirmButton = document.querySelector('.swal2-confirm') as HTMLElement;
        if (confirmButton) {
          confirmButton.style.backgroundColor = '#dc3545'; // Red color
          confirmButton.style.borderColor = '#dc3545';
          confirmButton.style.color = 'white';
        }
      }
    }).then((result) => {
      return result.isConfirmed;
    });
  }
}
